import { HeaderLinks } from 'components'
import { Header } from 'components'
import React from 'react'
import { Outlet } from 'react-router-dom'
import { colors } from '../components/Theme/WebTheme'

const dashboardRoutes = [];

const PublicLayout = () => {
    
    return (
        <div style={{backgroundColor : colors.LandingPage_Background, margin:'-8px'}}>
            <Header
                color="transparent"
                routes={dashboardRoutes}
                rightLinks={<HeaderLinks />}
                fixed
                changeColorOnScroll={{
                    height: 50,
                    color: "white"
                }}
            />
            <Outlet />
        </div>
    )
}

export default PublicLayout